import ApiFactory from '../factories/ApiFactory';
import UtilityService from '@/services/UtilityService';
import store from '../store';

const me = () => {
	return new Promise((resolve, reject) => {
		ApiFactory.get('v1/me?include=roles').then(
			(success) => {
				resolve(success.data);
			},
			(error) => reject(error)
		);
	});
};

const login = (user) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post('authenticationuser/v2/authentication', {
			...user,
			regId: window.firebaseToken,
			source: 'web',
		}).then(
			({ data }) => {
				if (!data.data.user?.restaurants) {
					store.dispatch('logout');
					reject('No restaurants found for this user...');
				} else {
					data.data.user.restaurants = UtilityService.sortByProp(
						data.data.user.restaurants,
						'restaurantName'
					);
					resolve(data.data);
				}
			},
			(error) => reject(error)
		);
	});
};

const loginB2B = (user) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post('posB2B/v1/authentication', {
			...user,
			regId: window.firebaseToken,
			source: 'web',
		}).then(
			({ data }) => {
				data.data.user.restaurants = UtilityService.sortByProp(data.data.user.restaurants, 'restaurantName');
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const changePassword = (userId, payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`/systemadmin/v1/users/${userId}/reset-password`, payload).then(
			(success) => resolve(success.data),
			(error) => reject(error)
		);
	});
};

const logout = () => {
	return new Promise((resolve, reject) => {
		ApiFactory.post('v1/logout').then(
			(success) => resolve(success.data),
			(error) => reject(error)
		);
	});
};

const deleteRegId = (userId, regId) => {
	return new Promise((resolve, reject) => {
		ApiFactory.delete(`posweb/v1/users/${userId}/logout/devices/${regId}`).then(
			(success) => resolve(success.data),
			(error) => reject(error)
		);
	});
};

const updateRegId = (userId, regId) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`posweb/v1/users/${userId}/updateRegId`, { token: regId, source: 'web' }).then(
			(success) => resolve(success.data),
			(error) => reject(error)
		);
	});
};

export default {
	me,
	login,
	changePassword,
	logout,
	deleteRegId,
	loginB2B,
	updateRegId,
};
